import { render, staticRenderFns } from "./WizardSearchIcon.vue?vue&type=template&id=50420576&scoped=true&"
import script from "./WizardSearchIcon.vue?vue&type=script&lang=js&"
export * from "./WizardSearchIcon.vue?vue&type=script&lang=js&"
import style0 from "./WizardSearchIcon.vue?vue&type=style&index=0&id=50420576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50420576",
  null
  
)

export default component.exports